// auto-generated by bin/genVersion.ts
export const VERSION = '2.3.1';
